import Tooltip from "@/tooltip";
import { Cog8ToothIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import Select from "react-select";
import { Actions as ALLOWANCEACTIONS } from "../../../store/actions/allowanceActions";
import { Actions as COMPANYACTIONS } from "../../../store/actions/companyActions";
import {useEffect, useMemo} from "react";
import AllowanceTypeOption from "./AllowanceTypeOption.json";
import { capitalize } from "lodash";

const TaxableOption = [
	{ label: "Pre Tax (yes)", value: 1 },
	{ label: "Post Tax (no)", value: 0 },
];

const AllowanceRow = ({
	allowanceTypeOptions,
	allowance,
	updateSetting,
	updateAdvisorSetting,
	disabled,
	openModal,
	jurisdiction,
	forModal,
	advisor,
	template,
}) => {

	const taxField = useMemo(() => {
		if (allowance?.method === "Notional Benefit") {
			return "benefits";
		} else {
			return "taxable";
		}
	}, [allowance?.method]);
	const nicField = useMemo(() => {
		if (allowance?.method === "Notional Benefit") {
			return "nic1A";
		} else {
			return "nicable";
		}
	}, [allowance?.method]);

	useEffect(() => {
		if (!forModal && !template) return;

		updateSetting(allowance.id, "name", allowance?.name);
		updateSetting(allowance.id, "method", allowance?.method);
		updateSetting(allowance.id, "methodId", allowance?.methodId);
		updateSetting(allowance.id, "forceTaxable", allowance?.forceTaxable);
		updateSetting(allowance.id, "taxable", allowance?.taxable);
		updateSetting(allowance.id, "nicable", allowance?.nicable);
		updateSetting(allowance.id, "nic1A", allowance?.nic1A);
		updateSetting(allowance.id, "pensionable", allowance?.pensionable);
	}, [template]);

	return (
		<div className="col-xs-12 form-inner-section pr-0 mb-0 pb-0 pt-6">
			<div
				className="col-xs-4"
				style={{ paddingLeft: 0 }}
			>
				<div className="form-material">
					<input
						id="allowance-type-name"
						className="form-control valid form-input"
						type="text"
						name="name"
						autoComplete="off"
						required
						onChange={(e) =>
							advisor
								? updateAdvisorSetting(
										allowance.id,
										e.target.name,
										e.target.value,
										e.target.forceTaxable,
									)
								: updateSetting(allowance.id, e.target.name, e.target.value, e.target.forceTaxable)
						}
						defaultValue={allowance.name}
						disabled={disabled || template}
					/>
					<label htmlFor="material-text">Name</label>

					{/* <div
              id=""
              className="help-block animated fadeInDown first-allowance-type-name hide"
            >
              Give a custom, recognisable name to the Allowance type you’re
              going to create.
            </div> */}
				</div>
			</div>

			<div className="col-xs-3">
				<div className="form-material">
					<Select
						valueName="selected"
						options={allowanceTypeOptions}
						value={AllowanceTypeOption.find((t) => t.value == allowance.methodId)}
						placeholder="Choose one"
						isDisabled={disabled || template}
						onChange={(e) => {
							if (advisor) {
								updateAdvisorSetting(allowance.id, "method", e.label);
								updateAdvisorSetting(allowance.id, "methodId", e.value);
								updateAdvisorSetting(allowance.id, "forceTaxable", e.forceTaxable);

								if (e.forceTaxable) {
									updateAdvisorSetting(allowance.id, "taxable", true);
								}

								return;
							}

							updateSetting(allowance.id, "method", e.label);
							updateSetting(allowance.id, "methodId", e.value);
							updateSetting(allowance.id, "forceTaxable", e.forceTaxable);

							if (e.forceTaxable) {
								updateSetting(allowance.id, "taxable", true);
							}
						}}
					/>
					<label htmlFor="example2-select2">Type</label>

					{/* <div
              id=""
              className="help-block animated fadeInDown first-allowance-type hide"
            >
              You only need to pick the Allowance type for now - amounts and/or
              rates will be set later for each individual employee. Not sure
              what each of the type means? We’ve got a great explainer in our
              Help Centre.
            </div> */}

					<div className="clearfix" />
				</div>
			</div>

			<div className="col-xs-4 px-0">
				<div className="col-xs-4 form-material p-0 p-0">
					<label htmlFor={`taxable-${allowance.id}`}>
						<Tooltip content={`Tick if this ${jurisdiction == "UK" ? "pay item" : "allowance"} is taxable`}>
							Taxable
						</Tooltip>
					</label>
					<div>
						<label className="css-input switch switch-sm switch-success mt-10">
						<input
							id={`taxable-${allowance.id}`}
							type="checkbox"
							disabled={disabled || template || (jurisdiction == "MT" && allowance?.forceTaxable)}
							checked={!!allowance[taxField]}
							onChange={() =>
								advisor
									? updateAdvisorSetting(allowance.id, taxField, !allowance[taxField])
									: updateSetting(allowance.id, taxField, !allowance[taxField])
							}
						/>
						<span></span>
					</label>
					</div>
				</div>

				<div className="col-xs-4 form-material p-0">
					{jurisdiction == "UK" && (
						<>
							<label
								htmlFor={`nicable-${allowance.id}`}
								style={{ marginBottom: 0 }}
							>
								<Tooltip content="Tick if NIC has to be deducted on this pay item">{capitalize(nicField)}</Tooltip>
							</label>
							<div>
								<label className="css-input switch switch-sm switch-success mt-10">
									<input
										id={`nicable-${allowance.id}`}
										type="checkbox"
										disabled={disabled || template}
										checked={!!allowance[nicField]}
										onChange={() =>
											advisor
												? updateAdvisorSetting(allowance.id, nicField, !allowance[nicField])
												: updateSetting(allowance.id, nicField, !allowance[nicField])
										}
									/>
									<span></span>
								</label>
							</div>
						</>
					)}
				</div>
				<div className="col-xs-4 form-material p-0">
					{jurisdiction == "UK" && (
						<>
							<label
								htmlFor={`pensionable-${allowance.id}`}
								style={{ marginBottom: 0 }}
							>
								<Tooltip content="Tick if Pension is to be deducted on this pay item - this only impacts pensions based on the Employee's pension plan">
									Pensionable
								</Tooltip>
							</label>
							<div>
								<label className="css-input switch switch-sm switch-success mt-10">
									<input
										id={`pensionable-${allowance.id}`}
										type="checkbox"
										disabled={disabled || template}
										checked={!!allowance.pensionable}
										onChange={() =>
											advisor
												? updateAdvisorSetting(allowance.id, "pensionable", !allowance.pensionable)
												: updateSetting(allowance.id, "pensionable", !allowance.pensionable)
										}
									/>
									<span></span>
								</label>
							</div>
						</>
					)}
				</div>
			</div>

			<div className="col-xs-1">
				{!forModal && !disabled && !advisor ? (
					<div
						className="pull-right"
						onClick={() => openModal(allowance.id, jurisdiction == "UK" ? "Pay Item" : "Allowance")}
						style={{ marginTop: "1.25em", cursor: "pointer" }}
					>
						<Tooltip content="Advanced Settings">
							<Cog8ToothIcon style={{ height: "2em" }} />
						</Tooltip>
					</div>
				) : null}
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	let jurisdiction = state.company?.settings?.jurisdiction;

	if (ownProps.forModal) jurisdiction = state.company?.newCompany?.jurisdiction;
	if (ownProps.advisor) jurisdiction = state.advisors?.settings?.jurisdiction

	return {
		allowanceTypeOptions: AllowanceTypeOption.filter((t) => t.jurisdiction.includes(jurisdiction)),
		jurisdiction,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateSetting: (id, field, newValue) =>
		dispatch(ALLOWANCEACTIONS.updateSetting(id, field, newValue, !!ownProps.forModal)),
	updateAdvisorSetting: (id, field, newValue) => dispatch(ALLOWANCEACTIONS.updateAdvisorSetting(id, field, newValue)),
	openModal: (allowance, item) => dispatch(COMPANYACTIONS.advancedSettingsModal(allowance, item || "Allowance")),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllowanceRow);
